export const OperationProcessLinkViewIds = {
    buttonCreate: 'operation-process-link-view-button-create-new-process-',
    buttonUnlinkProcess: 'operation-process-link-view-button-unlink-process-new-process',
    buttonLinkProcess: 'operation-process-link-view-button-link-process-new-process',
    warningContainerProcessLinkOperationApiChanged: 'operation-process-link-view-warning-container-process-link-operation-api-changed',
};

export const OperationRowIds = {
    smalltextApiOperationSummary: 'operation-row-smalltext-api-operation-summary',
};

export const SwaggerEditorIds = {
    swaggerEditor: 'swagger-editor',
    buttonSave: 'swagger-editor-button-save',
};

export const ListViewIds = {
    buttonCreateNewApi: 'list-view-button-create-new-api',
    searchInput: 'list-view-search-input',
    listItemApiName: 'list-view-api-',
};

export const ContentPanelIds = {
    buttonViewMonitoring: 'content-panel-view-monitoring',
    buttonEdit: 'content-panel-button-edit',    
    buttonDeploy: 'content-panel-button-deploy',
    buttonApiPassthrough: 'content-panel-button-api-passthrough',
    panelButtons: 'content-panel-panel-buttons',
    buttonUpdateProcesses: 'content-panel-button-update-processes',
    panelApiContent: 'content-panel-api-content-panel',
    buttonDelete: 'content-panel-button-delete',
    panelError: 'content-panel-panel-error',
};

export const ProcessInstanceListContainerIds = {
    textAreaAcknowledge: 'process-instance-list-container-textarea-acknowledge',
    textAreaComment: 'process-instance-list-container-textarea-comment',
    buttonConfirmComment: 'process-instance-list-container-button-confirm-comment',
    flexContainerMain: 'process-instance-list-container-flexcontainer-main-container',
    flexItemFilepicker: 'process-instance-list-container-filepicker',
    flexItemInstanceChart: 'process-instance-list-container-instance-chart',
    formGroupToolbar: 'process-instance-list-toolbar',
    buttonConfirmAcknowledge: 'process-instance-list-button-confirm-acknowledge',
    buttonAcknowledgeAll: 'process-instance-list-button-acknowledgeall',
    buttonDeleteFinished: 'process-instance-list-button-deletefinished',
    buttonDeleteSuccessful: 'process-instance-list-button-deletesuccessful',
    buttonSaveAllAsCSV: 'process-instance-list-button-saveall-as-csv',
    buttonAcknowledgeSelected: 'process-instance-list-button-acknowledgeselected',
    buttonCommentSelected: 'process-instance-list-button-commentselected',
    buttonDeleteSelected: 'process-instance-list-button-deleteselected',
    buttonRehydrateProcess: 'process-instance-list-button-rehydrateprocess',
    buttonSaveSelected: 'process-instance-list-button-saveselected',
    buttonTerminateSelected: 'process-instance-list-button-terminateselected',
    flexContainerListSearch: 'process-instance-list-container-flexcontainer-list-search',
    formGroupInstanceList: 'process-instance-list-formgroup-instance-list',
    selectorHasMoreInstances: 'process-instance-list-has-more-instances-container-selector',
    linkClearFilter: 'process-instance-list-clear-instance-filters-selector',
};

export const NewSchemaEditorIds = {
    inputNewVariableName: 'new-schema-editor-input-new-variable-name',
    newVariableTypeSelect: 'new-schema-editor-new-variable-type-select',
    inputNewVariableTypeSelect: 'new-schema-editor-input-new-variable-type-select',
    buttonCancelNewVariable: 'new-schema-editor-button-cancel-new-variable',
    buttonCreateNewVariable: 'new-schema-editor-button-create-new-variable',
    buttonCreateNewVariableSchema: 'new-schema-editor-button-create-new-variable-schema',
    buttonCreateNewChildVariableDropdown: 'new-schema-editor-button-create-new-child-variable-dropdown',
    inputVariableImportFileInput: 'new-schema-editor-new-variable-import-file-input',
    buttonExportAllSchemas: 'new-schema-editor-button-export-all-schemas',
    buttonImportChildVariable: 'new-schema-editor-button-import-child-variable',
    buttonCreateNewChildVariablePart: 'new-schema-editor-button-create-new-child-variable',
    inputNewVariableDescription: 'new-schema-editor-input-new-variable-description'
};

export const PanelContentids = {
    textAreaSchemaDescriptionInput: 'panel-content-textarea-schema-description-input',
    buttonDiscardDescriptionChanges: 'panel-content-button-discard-description-changes',
    buttonSaveDescriptionChanges: 'panel-content-button-save-description-changes',
};


export const EnvironmentVariablesIds = {
    inputName: 'environment-variables-input-name',
    buttonConfirmName: 'environment-variables-button-confirm-name',
    buttonSaveChanges: 'environment-variables-button-save-changes',
};

export const ApiVersionModalIds = {
    buttonApiDeploy: 'api-version-modal-button-deploy',
    buttonApiRollback: 'api-version-modal-button-rollback',
    buttonApiSaveDeploy: 'api-version-modal-button-save-deploy',
};


export const AgentEventsIds = {
    inputSearchSelector: 'agent-events-input-search-selector',
    formGroupSearchSelector: 'agent-events-form-group-event-search-selector',
    agentTable: 'agent-events-table',
};


export const AgentLevelContentIds = {
    linkEditAgentButton: 'agent-level-content-link-edit-agent-button',    
};

export const AgentLevelEditContentIds = {
    formGroupAgentNameInput: 'agent-level-edit-content-form-group-agent-name-input',
    formGroupUsernameInput: 'agent-level-edit-content-form-group-username-input',
    formGroupPasswordInput: 'agent-level-edit-content-form-group-password-input',
    formGroupHttpsTriggersPortsInput: 'agent-level-edit-content-form-group-https-triggers-ports-input',
    formGroupHttpTriggersPortsInput: 'agent-level-edit-content-form-group-http-triggers-ports-input',
    formGroupFriendlyUrlInput: 'agent-level-edit-content-form-group-friendly-url-input',
    formGroupCertificateThumbprintInput: 'agent-level-edit-content-form-group-certificate-thumbprint-input',
    formGroupCloudAgentFriendlyUrl: 'agent-level-edit-content-form-group-cloud-agent-friendly-url',
    inputName: 'agent-level-edit-content-input-name',
    inputUsername: 'agent-level-edit-content-input-username',
    inputPassword: 'agent-level-edit-content-input-password',
    inputHttpsTriggerPorts: 'agent-level-edit-content-input-https-trigger-ports',
    inputHttpTriggerPorts: 'agent-level-edit-content-input-http-trigger-ports',
    inputFriendlyUrl: 'agent-level-edit-content-input-friendly-url',
    inputCertificateThumbprint: 'agent-level-edit-content-input-certificate-thumbprint',
};

export const AgentTriggersIds = {
    formGroupAgentTriggetsPanelTogle: 'agent-triggers-form-group-triggers-panel-toggle',
    agentTriggersListPanel: 'agent-triggers-agent-triggers-list',
    agentTriggersContentPanel: 'agent-triggers-content-panel',
};

export const AgentGroupLevelContentIds = {
    inputAgentGroupName: 'agent-group-level-content-agent-group-name',
    buttonAgentGroupActionsPart: 'agent-group-level-button-agent-group-actions',
    formGroupAgentGroupNameInput: 'agent-group-level-form-group-agent-group-name-input',
    flexContainerEditorForm: 'agent-group-level-agent-group-editor-form',
    formGroupConnectionStringInput: 'agent-group-level-form-group-connection-string-input',
    inputConnectionString: 'agent-group-level-input-connection-string',
    formGroupHastLimitedAgentsWarning: 'agent-group-level-form-group-has-limited-agents-warning',
    formGroupAdvancedSettingsSelector: 'agent-group-level-form-group-agent-group-advanced-settings-selector',
    labelAdvancedSettingsSelector: 'agent-group-level-advanced-settings-selector',
    toggleDivContainerAllowRunningTestprocessesToggle: 'agent-group-level-allow-running-test-processes-toggle',
    toggleDivContainerEnableCrossplatformToggle: 'agent-group-level-enable-cross-platform-toggle',
    toggleDivContainerLogStepsToBlobsToggle: 'agent-group-level--steps-to-blobs-toggle',
    selectAgentRegistrationMode: 'agent-group-level-select-agent-registration-mode',
    customToggleAllowRunningTestProcessesId: 'agent-group-level-custom-toggle-allow-running-test-processes-id',
    customToggleEnableCrossPlatformId: 'agent-group-level-custom-toggle-enable-cross-platform-id',
    customToggleLogStepsToBlobsId: 'agent-group-level-custom-toggle-log-steps-to-blobs-id',
    styledLinkDownloadConfig: 'agent-group-level-link-download-config',
    buttonDeleteAllOfflineAgents: 'agent-group-level-button-delete-all-offline-agents',
    formGroupDefaultExternalAddressInput: 'agent-group-level-form-group-default-external-address-input',
    inputDefaultExternalAddress: 'agent-group-level-input-default-external-address',
    formGroupExecutionAgentsList: 'agent-group-level-form-group-execution-agents-list',
    linkNewAgentButton: 'agent-group-level-link-new-agent-button',
    formGroupGatewayAgentsList: 'agent-group-level-form-group-gateway-agents-list',
    linkNewGatewayAgentButton: 'agent-group-level-link-new-gateway-agent-button',
};

export const EnvironmentLevelContentIds = {
    formGroupEnvironmentNameInput: 'environment-level-content-form-group-environment-name-input',
    inputEnvironmentName: 'environment-level-content-input-environment-name',
    formGroupAgentGroupsList: 'environment-level-content-form-group-agent-groups-list',
    linkNewAgentGroupButton: 'environment-level-content-link-new-agent-group-button',
    formGroupEnvironmentColorPicker: 'environment-level-content-form-group-environment-color-picker',
    toggleDivContainerRequireMcpConfirmationToggle: 'environment-level-content-toggle-div-container-require-mcp-confirmation-toggle',
    customToggleRequireMcpConfirmationId: 'environment-level-content-custom-toggle-require-mcp-confirmation',
};

export const EnvironmentListIds = {
    linkNewEnvironmentButton: 'environment-list-new-environment-button',    
    containerEnvironmentsList: 'environment-list-container-environments-list',
};

export const ApiPolicyIdentitiesIds = {
    fieldsetSection: 'api-policy-identities-section',
    buttonNewIdentity: 'api-policy-identities-button-new-identity',
    togglePublicAccess: 'api-policy-identities-toggle-oublic-access',    
};

export const ApiPolicyRequestLoginOptionsIds = {
    fieldsetSection: 'api-policy-request-login-options-section',
    buttonNewIdentity: 'api-policy-request-login-options-button-new-configuration',
};


export const ApiPolicyTargetedEndpointsIds = {
    fieldsetSection: 'api-policy-targeted-endpoints-section',
    buttonNewEndpoint: 'api-policy-targeted-endpoints-new-endpoint-button',
    flexContainerThrottling: 'api-policy-targeted-endpoints-throttling',
    selectMethodIndexed: 'api-policy-targeted-endpoints-method-',
    inputEndpointsPathIndexed: 'api-policy-targeted-endpoints-path-',
    buttonDeleteIndexed: 'api-policy-targeted-endpoints-delete-button-',
};

export const ApiPolicyIdentityApiKeyIds = {
    modalId: "api-policies-add-api-key",
    apiKeySelector: "api-policy-add-api-key-selector"
}
